import { apiClient } from '../client';

/**
 * Cria colaborador manualmente (RH).
 * Backend gera login e senha numéricos de 6 dígitos.
 * @param {{ name: string }} payload
 * @returns {Promise<{ status: boolean, message: string, data: { id: number, name: string, login: string, password: string } }>}
 */
export const createCollaborator = async (payload) => {
  const { data } = await apiClient.post('/users/collaborators', payload);
  return data;
};

/**
 * Lista colaboradores com acesso ao app (isColaborator = true), com paginação.
 * Busca por nome ignora underscores. Filtro opcional apenas responsáveis.
 * @param {{ name?: string, onlyResponsibles?: boolean, page?: number, limit?: number }} params
 * @returns {Promise<{ collaborators, total, page, limit, totalPages }>}
 */
export const listCollaborators = async (params = {}) => {
  const { data } = await apiClient.get('/users/collaborators', { params });
  return data;
};

